import { isDefined } from 'wix-rich-content-common';
import { DEFAULT_PALETTE } from '../defaults.js';

const resolveColors = (args) => {
  var _a, _b;
  return [
    ...DEFAULT_PALETTE,
    ...args.colors ? Object.values(args.colors) : [],
    ...(_b = (_a = args.getColorFn) == null ? void 0 : _a.call(args)) != null ? _b : [],
    args.currentColor
  ].filter(isNotEmpty).map(toUpperCase).filter(isNotDuplicate).slice(-12);
};
const isNotEmpty = (c) => isDefined(c) && c !== "";
const toUpperCase = (c) => c.toUpperCase();
const isNotDuplicate = (item, index, itemArray) => itemArray.indexOf(item) === index;

export { resolveColors };
//# sourceMappingURL=resolve-colors.js.map
